export const COLOR_FLAVIA_BLUE = "#05326e";
export const COLOR_SKY_BLUE = "#87ceeb";
export const COLOR_FOREST_GREEN = "#228b22";
export const COLOR_PALE_GREEN = "#98fb98";
export const COLOR_ORCHID = "#da70d6";
export const COLOR_MAROON = "#800000";
export const COLOR_SANDY_BROWN = "#f4a460";
export const COLOR_CANARY_YELLOW = "#ffff8f";
export const predefinedColorsLabelled = [
    { value: COLOR_FLAVIA_BLUE, label: "Flavia blue" },
    { value: COLOR_SKY_BLUE, label: "Sky blue" },
    { value: COLOR_FOREST_GREEN, label: "Forest green" },
    { value: COLOR_PALE_GREEN, label: "Pale green" },
    { value: COLOR_ORCHID, label: "Orchid" },
    { value: COLOR_MAROON, label: "Maroon" },
    { value: COLOR_SANDY_BROWN, label: "Sandy brown" },
    { value: COLOR_CANARY_YELLOW, label: "Canary yellow" }
];
export function numToHex(num) {
    return "#" + num.toString(16).padStart(6, "0");
}
export function hexToNum(hex) {
    return parseInt(hex.replace("#", ""), 16);
}
export function randomPredefinedColor() {
    return predefinedColorsLabelled[Math.floor(Math.random() * predefinedColorsLabelled.length)].value;
}
